<template>
  <div class="main-chapter1">
    <div class="chapter-title">Общие сведения</div>
    <n-items v-if="project">
      <n-input title="Наименование организации, выполняющей работы" :value.sync="data.genExecutor" />
      <n-input title="Наименование объекта строительства" :value.sync="project.title" />
      <n-input title="Должность, фамилия, инициалы и подпись лица, ответственного за монтажные работы и ведение журнала" :value.sync="data.prorab" />
      <n-input title="Организация, разработавшая проектную документацию, чертежи КЖ, КМ, КД" :value.sync="data.genProject" />
      <n-input title="Шифр проектов" :value.sync="data.q1" />
      <n-input title="Организация, разработавшая проект производства работ" :value.sync="data.q2" />
      <n-input title="Шифр проектов" :value.sync="data.q3" />
      <n-input title="Предприятие, изготовившее конструкции" :value.sync="data.q4" />
      <n-input title="Шифр заказов" :value.sync="data.q5" />
      <n-input title="Заказчик (организация), должность, фамилия, инициалы и подпись руководителя (представителя) технического надзора" :value.sync="data.client" />
      <n-input title="Основные показатели строящегося объекта" :value.sync="data.q6" />
      <n-input title="Объем работ, стальных конструкций, т" :value.sync="data.q7" />
      <n-input title="сборных железобетонных конструкций, м3" :value.sync="data.q8" />
      <n-input title="деревянных конструкций, м3" :value.sync="data.q9" />
      <n-input title="Журнал начат" :value.sync="data.now" />
      <n-input title="Журнал окончен" :value.sync="data.q10" />
      <n-button @click="submit" color="success">Сохранить</n-button>
    </n-items>
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: [ 'project', 'data', ],
  data: () => ({
    subcontractors: [
      { name: '', bin: '', works: '', },
    ],
    columns: [
      { name: 'name', title: 'Наименование', },
      { name: 'bin', title: 'БИН', },
      { name: 'works', title: 'Работы', },
    ],
    columnsRecords: [
      { name: 'date', title: 'Дата', },
      { name: 'record', title: 'Пояснение', },
    ],
  }),
  methods: {
    submit() {
      this.$var('load', true)
      setTimeout(() => this.$var('load', false), 400)
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
